import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { ButtonBase, Tooltip } from "@mui/material";
import { alpha } from "@mui/material/styles";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { getAddressFieldTypeOption } from "./addressFieldTypes";
import addressFieldUi from "./addressFieldUi";

const AddressFieldActionControl = ({ onEdit, value }) => {
  const intl=useIntl(), option=getAddressFieldTypeOption(value), StatusIcon=option.icon;
  const property=intl.formatMessage({ id:option.messageId, defaultMessage:option.label });
  return <Tooltip title={intl.formatMessage({ id:"addresses.fieldEditor.actionTooltip" },{ property })} placement="top" arrow>
    <ButtonBase aria-label={intl.formatMessage({ id:"addresses.fieldEditor.actionAria" },{ property })} onClick={onEdit}
      sx={{ width:48, height:36, flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center", gap:.22,
        border:`1px solid ${addressFieldUi.borderStrong}`, borderRadius:.9, bgcolor:"#fff", color:addressFieldUi.muted,
        transition:"border-color 120ms ease, background-color 120ms ease, box-shadow 120ms ease, color 120ms ease",
        "&:hover":{ borderColor:theme=>alpha(theme.palette.primary.main,.32), bgcolor:theme=>alpha(theme.palette.primary.main,.035), color:"primary.main" },
        "&:focus-visible":{ outline:"none", borderColor:"primary.main", boxShadow:theme=>`0 0 0 3px ${alpha(theme.palette.primary.main,.07)}` } }}>
      <EditOutlinedIcon sx={{ fontSize:13.5, color:"primary.main" }}/>
      <StatusIcon sx={{ fontSize:14.5, color:value === "REQUIRED" ? "primary.main" : value === "DONT_CARE" ? addressFieldUi.subtle : addressFieldUi.muted }}/>
    </ButtonBase>
  </Tooltip>;
};

AddressFieldActionControl.propTypes = { onEdit:PropTypes.func.isRequired, value:PropTypes.string.isRequired };
export default AddressFieldActionControl;
